export default __webpack_public_path__ + "static/media/svg-2.d4a97349.svg";